import React, { useMemo } from 'react';
import { toCoins } from 'services/financial';

import { AdjustmentList } from 'components/pages/study/ExpenseFixed/ExpenseFixedList/FullExpenseFixedInformation/AdjustmentList/AdjustmentList';

import { getNormalizedDate } from '../../ExpensesServices';

import { CommentSection } from './CommentSection/CommentSection';
import { ExpenseInfoItem } from './ExpenseInfoItem/ExpenseInfoItem';

export const FullFixedExpenseInformation = ({
  editCommentMode,
  editedComment,
  setEditedComment,
  setEditCommentMode,
  editedExpensesFixed,
  isUserHaveAccessToManageExpenses
}) => {
  const parentExpenseFixed = useMemo(() => editedExpensesFixed.find(expense => expense.adjustmentSequence === 0), [
    editedExpensesFixed
  ]);

  const clientAmountSum = useMemo(() => {
    return editedExpensesFixed.reduce((sum, expense) => sum + (expense.clientAmount || 0), 0);
  }, [editedExpensesFixed]);

  return (
    <>
      <CommentSection
        editCommentMode={editCommentMode}
        editedComment={editedComment}
        setEditedComment={setEditedComment}
        comments={parentExpenseFixed?.comments}
        setEditCommentMode={setEditCommentMode}
        isUserHaveAccessToManageExpenses={isUserHaveAccessToManageExpenses}
      />
      <ExpenseInfoItem label="Event Date" text={getNormalizedDate(parentExpenseFixed?.date)} />
      <ExpenseInfoItem label="Revenue Date" text={getNormalizedDate(parentExpenseFixed?.elligoRevenueDate)} />
      <ExpenseInfoItem label="Fixed Expense - Event Name" text={parentExpenseFixed?.event || 'N/A'} />
      <AdjustmentList
        expenses={editedExpensesFixed.map(row => ({ ...row, clientAmount: toCoins(row.clientAmount) }))}
        expenseType={'Fixed'}
      />
      {isUserHaveAccessToManageExpenses && (
        <ExpenseInfoItem label="Amount" text={`$${clientAmountSum.toLocaleString()}` || 'N/A'} />
      )}
      <ExpenseInfoItem label="Status" text={parentExpenseFixed?.eventStatus || 'N/A'} />
      <ExpenseInfoItem label="Added By" text={parentExpenseFixed?.addedBy || 'N/A'} />
    </>
  );
};
